import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IThread } from '../interfaces/living-lab/IThread';
import { IThreadComment } from '../interfaces/living-lab/IThreadComment';
import type { Geometry } from 'geojson';

export interface CommentData {
  geometry: Geometry;
  layerUUID: string | null;
  mainComment: string;
}

@Injectable({
  providedIn: 'root'
})
export class LivingLabService {
private http: HttpClient = inject(HttpClient);
public sidebarWidth$ = new BehaviorSubject<number>(400);
public sidebarLivinglabOpenSubject$ = new BehaviorSubject<boolean>(false);
public commentData$ = new BehaviorSubject<CommentData | null>(null);
public selectedThreadForDetails$ = new BehaviorSubject<IThread | null>(null);
public isAddingComment$ = new BehaviorSubject<boolean>(false);
private API_URL: string = environment.services.urlEDI;
 

  constructor() { }

    expandSidebar(value: number) {
    this.sidebarWidth$.next(value);
  }

  openLivinglab(value: boolean) {
    this.sidebarLivinglabOpenSubject$.next(value);
  }

  // Nuovo metodo per aprire direttamente i dettagli di un thread specifico
  openThreadDetails(thread: IThread) {
    // Prima chiudi i dettagli attuali per forzare l'aggiornamento
    this.selectedThreadForDetails$.next(null);
    
    // Poi apri i nuovi dettagli dopo un breve delay per assicurarsi che il componente si aggiorni
    setTimeout(() => {
      this.selectedThreadForDetails$.next(thread);
      this.sidebarLivinglabOpenSubject$.next(true);
    }, 10);
  }

  // Metodo per chiudere i dettagli del thread
  closeThreadDetails() {
    this.selectedThreadForDetails$.next(null);
  }

  setCommentData(data: CommentData) {
    this.commentData$.next(data);
  }

  clearCommentData() {
    this.commentData$.next(null);
  }

  createThread(content: string, vectorUUID: string, geometry: Array<number> , project_uuid :string) : Observable<void> {
      return this.http.post<void>(`${this.API_URL}/explorer_thread`, {content: content, vector_uuid: vectorUUID, geometry: geometry , project_uuid});
  }

  loadThreads(project_uuid :string) : Observable<Array<IThread>> {
    return this.http.get<Array<IThread>>(`${this.API_URL}/explorer_thread/${project_uuid}`);
  }

  loadThreadComments(thread_uuid: string): Observable<Array<IThreadComment>> {
    return this.http.get<Array<IThreadComment>>(`${this.API_URL}/explorer_thread_comment/${thread_uuid}`);
  } 

  sendComment(thread_uuid: string, content: string): Observable<void> {
    return this.http.post<void>(`${this.API_URL}/explorer_thread_comment/`, {thread_uuid: thread_uuid, content: content});
  }

  sendReply(comment_uuid: string, content: string): Observable<void> {
    return this.http.post<void>(`${this.API_URL}/edi_explorer_thread_comment_reply/`, {comment_uuid: comment_uuid, content: content});
  }
}
